module.exports = __webpack_public_path__ + "img/2.a32d0815.png";